export enum CardVariant {
  PRIMARY = "primary",
  CAROUSEL = "carousel",
  IMAGE = "image",
}

export enum CardSize {
  REGULAR = "regular",
  LARGE = "large",
  TALL = "tall",
}
